@if(conceptSteps.filterContainers?.length > 1){
  <ul class="common-stepper__list">
    @for (fieldContainer of conceptSteps.filterContainers; track $index) {
      <li class="common-stepper__list-item"
        [ngClass]="{'common-stepper__list-item-grow': !$last}">
        <div class="common-stepper__step-container">
          <button class="common-stepper__button-step"
            [ngClass]="{'common-stepper__button-step--active': fieldContainer.active}"
            (click)="selectStep(fieldContainer)"
            [pTooltip]="fieldContainer.name"
            tooltipPosition="bottom"
            [disabled]="fieldContainer.active">
            <p class="common-stepper__button-text">
              {{fieldContainer.index}}
            </p>
          </button>
          @if (!$last) {
            <hr class="common-stepper__step-line"
              [ngClass]="{ 'common-stepper__step-line--active': fieldContainer.active }" />
          }
        </div>
      </li>
    }
  </ul>
}

